import React from "react";

const Loading = () => {
    return (<div className="row loading"><img src="/assets/images/loading.gif" alt=""/></div>)
}
export default Loading;